import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const TransferIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 20 20"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M2.72 5.42C2.42 5.7 2.43 6.11 2.72 6.37L6.5 9.92C6.63 10.05 6.82 10.13 6.99 10.13C7.37 10.13 7.64 9.87 7.64 9.5C7.64 9.32 7.57 9.18 7.45 9.06L5.87 7.59L4.5 6.46L6.2 6.53H16.01C16.39 6.53 16.66 6.27 16.66 5.89C16.66 5.53 16.39 5.27 16.01 5.27H6.2L4.5 5.33L5.87 4.2L7.45 2.73C7.57 2.61 7.64 2.47 7.64 2.29C7.64 1.92 7.37 1.67 6.99 1.67C6.82 1.67 6.63 1.74 6.5 1.86L2.72 5.42ZM16.45 14.58C16.74 14.3 16.74 13.9 16.45 13.63L12.67 10.07C12.54 9.95 12.35 9.87 12.18 9.87C11.79 9.87 11.53 10.13 11.53 10.49C11.53 10.68 11.59 10.82 11.71 10.93L13.3 12.41L14.67 13.54L12.97 13.47H3.16C2.78 13.47 2.5 13.73 2.5 14.1C2.5 14.47 2.78 14.73 3.16 14.73H12.97L14.67 14.66L13.3 15.8L11.71 17.27C11.59 17.39 11.53 17.53 11.53 17.71C11.53 18.08 11.79 18.33 12.18 18.33C12.35 18.33 12.54 18.26 12.67 18.14L16.45 14.58Z" />
		</svg>
	)
}

export default TransferIcon
